import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
} from "../services/types/ComponentTypes";

export const screen_157_qc_approve: any[] = [
            {
                "componentType": "screenGroup",
                "title": "Quality check approval",
                "BindValue": "con_vehicle_approval",
                "style": {},
                "childComponents": [
                    {
                        "componentType": "form",
                        "Name": "qc_approval_add",
                        "columnNumber": "m1 t1 w1",
                        "TableName": "service_qc_approval",
                        "DisplayName": "QC Approval",
                        "Workflow": "service",
                        "DisableSubmit": true,
                        "BindValue": "qc_approve_add",
                        "SubmitActions": [
                            {
                                "Action": "Navigate",
                                "Navigate": "modulev1/vehicleinsummary"
                            }
                        ],
                        "formActions": [
                            {
                                "name": "lock",
                                "icon": "lock",
                                "onPressAction": "unlock"
                            },
                            {
                                "name": "Proforma Invoice",
                                "icon": "receipt",
                                "onPressAction": "Navigate",
                                "ScreenId": "175"
                            }
                        ],
                        "style": {
                            "backgroundColor": "#ffffff",
                            "direction": "column",
                            "padding": 10
                        },
                        "Fields": [
                            {
                                "componentType": "group",
                                "Label": "",
                                "BindValue": "cont_Action",
                                "style": {
                                    "direction": "row",
                                    "padding": 0,
                                    "margin": 0,
                                    "marginBottom": 8
                                }
                            },
                            {
                                "componentType": "fieldGroup",
                                "Label": "QC approval details",
                                "BindValue": "con_approval_details",
                                "style": {
                                    "direction": "column"
                                },
                                "childComponents": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "QC approval No.",
                                        "PlaceHolder": "Will be auto generated...",
                                        "IsMandatory": false,
                                        "BindValue": "txt_approved_number",
                                        "Json_Attribute": "qc_no",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "AutoPopulate": true,
                                        "IsReadOnly": true,
                                        "AutoPopulate_format": "QCAP_[******]",
                                        "IsVerticalView": true,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VIN No.",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "parentid",
                                        "Json_Attribute": "parent_id",
                                        "componentType": "searchableDropdown",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "LookupName": "qc_vin_no",
                                        "IsVerticalView": true,
                                        "AutoSelect": "parentid"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "QC approve status",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "qc_approve_status",
                                        "Json_Attribute": "qc_approve_status",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "enableNextState": true,
                                        "options": [
                                            {
                                                "label": "QC Approved",
                                                "value": "QC Approved"
                                            },
                                            {
                                                "label": "QC Rejected",
                                                "value": "QC Rejected"
                                            }
                                        ]
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Closed job card",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "file_closed_jobcard",
                                        "Json_Attribute": "closed_jobcard_attachment",
                                        "componentType": "files",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Others",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "file_others",
                                        "Json_Attribute": "Others_attachment",
                                        "componentType": "files",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "Label": "",
                                        "BindValue": "qc_details",
                                        "componentType": "report",
                                        "IncludeLabel": true,
                                        "Settings": "qc_approval",
                                        "Parent_Field": "parentid"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "componentType": "button",
                        "name": "Submit",
                        "Label": "Submit",
                        "BindValue": "submit",
                        "onPressAction": "save",
                        "ScreenId": "157",
                        "next_action": "QC Approve",
                        "ActionType": "Add",
                        "Enabled": {
                            "Enable": {
                                "Json_Attribute": "current_state",
                                "values": [
                                    "Job card",
                                    "QC Approved",
                                    "QC Rejected"
                                ]
                            },
                            "Mode": [
                                "Edit",
                                "Add"
                            ]
                        },
                        "style": {
                            "textColor": "#FFFFFF",
                            "padding": 8,
                            "borderRadius": 4,
                            "fontSize": 14
                        }
                    }
                ]
            }
        ];
